import script from "./FeedbackDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackDialog.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackDialog.vue?vue&type=style&index=0&id=56287760&lang=scss&scoped=true"

import exportComponent from "/workdir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56287760"]])

export default __exports__